module.exports = __webpack_public_path__ + "static/pool-p-bb3c8868ac18be26c054409c9a3bb885.svg";